import { SPACING } from 'd2/constants'
import { px } from 'd2/utils/style'
import makeStyles from 'd2/hooks/tss/makeStyles'

const styles = () => ({
  trackNumber: {
    padding: `0 ${px(SPACING)}`,
  },
} as const)

export default makeStyles({
  name: 'Playlist',
})(styles)
